import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import App from './App';
import TerminosYCondiciones from './pages/TerminosYCondiciones';
import PoliticasDePrivacidad from './pages/PoliticasDePrivacidad';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';

/**
 * Reads the current pathname and sets the i18n language accordingly.
 * Paths starting with /en/ (or exactly /en) use English; everything else uses Spanish.
 */
const LanguageSyncer: React.FC = () => {
  const { i18n } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    const isEnglish = pathname === '/en' || pathname.startsWith('/en/');
    const targetLang = isEnglish ? 'en' : 'es';
    if (i18n.language !== targetLang) {
      i18n.changeLanguage(targetLang);
    }
  }, [pathname, i18n]);

  return null;
};

const AppRouter: React.FC = () => (
  <BrowserRouter>
    <LanguageSyncer />
    <Routes>
      {/* ── Spanish routes (default) ── */}
      <Route path="/" element={<App />} />
      <Route path="/terminos_y_condiciones" element={<TerminosYCondiciones />} />
      <Route path="/politicas-de-privacidad" element={<PoliticasDePrivacidad />} />

      {/* ── English routes ── */}
      <Route path="/en" element={<App />} />
      <Route path="/en/" element={<App />} />
      <Route path="/en/terms_and_conditions" element={<TermsAndConditions />} />
      <Route path="/en/privacy-policy" element={<PrivacyPolicy />} />

      {/* ── Fallback ── */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter>
);

export default AppRouter;
